'use strict';

angular.module('myConsultApp')
    .directive('progressBar', function () {
      return {
        templateUrl: 'templates/progressBar.html',
        restrict: 'E',
        scope: {
          currentStep: '=',
          barValue: '='
        },
        link: function(scope, elem, attr){

          scope.orange = '#ff6400';
          scope.blue = '#0096af';

        }
      };
    });
